<div #parentContainer class="flex h-full justify-center items-start relative">
    @if(showLoading()) {
    <div class="w-full mx-auto px-6 py-4 space-y-4">
        <!-- Title -->
        <p-skeleton width="60%" height="2rem" class="mb-6"></p-skeleton>

        <!-- Paragraph lines -->
        <div class="space-y-2">
            <p-skeleton width="100%" height="1.25rem"></p-skeleton>
            <p-skeleton width="100%" height="1.25rem"></p-skeleton>
            <p-skeleton width="90%" height="1.25rem"></p-skeleton>
        </div>

        <div class="space-y-2 pt-2">
            <p-skeleton width="100%" height="1.25rem"></p-skeleton>
            <p-skeleton width="85%" height="1.25rem"></p-skeleton>
        </div>

        <div class="space-y-2 pt-2">
            <p-skeleton width="100%" height="1.25rem"></p-skeleton>
            <p-skeleton width="95%" height="1.25rem"></p-skeleton>
            <p-skeleton width="80%" height="1.25rem"></p-skeleton>
        </div>
    </div>
    }
    @else {
    <div #editorContainer class="prose overflow-y-auto max-h-full w-full"></div>
    }

    <!-- Floating Toolbar -->
    @if (showToolbar && editorView && !showInput) {
    <div #toolbar class="floating-toolbar p-1" [style.top.px]="toolbarPosition.top"
        [style.left.px]="toolbarPosition.left">
        <app-button class="toolbar-button ask-bob-button" variant="ghost" size="xs" (clicked)="onAskBob()">
            <div class="flex items-center gap-2">
                <app-icon [type]="'message-circle-plus'" source="lucide" size="default"
                    class="text-gray-500"></app-icon>
                <span class="text-sm font-medium">Ask Bob</span>
            </div>
        </app-button>

        <div class="toolbar-separator"></div>

        <div class="flex items-center gap-1">
            <app-button class="toolbar-format-button" variant="ghost" size="xs" (clicked)="onToggleBold()"
                toolTip="Bold">
                <app-icon [type]="GENERAL_AGENT_SVG.BOLD" source="svg" size="sm"></app-icon>
            </app-button>

            <app-button class="toolbar-format-button" variant="ghost" size="xs" (clicked)="onToggleItalic()"
                toolTip="Italic">
                <app-icon [type]="GENERAL_AGENT_SVG.ITALIC" source="svg" size="sm"></app-icon>
            </app-button>

            <div class="headings-button-wrapper relative">
                <app-button class="toolbar-format-button" variant="ghost" size="xs"
                    (clicked)="onToggleHeadingsPanel($event)" toolTip="Text Style">
                    <app-icon [type]="GENERAL_AGENT_SVG.TRANSFORM" source="svg" size="sm"></app-icon>
                </app-button>

                @if (showHeadingsPanel) {
                <div #headingsPanel class="headings-panel" [class.headings-panel-above]="headingsPanelAbove">
                    <button class="heading-option" (click)="onHeadingSelected('heading', 1, $event)">
                        <div class="heading-preview heading-1">Heading 1</div>
                    </button>
                    <button class="heading-option" (click)="onHeadingSelected('heading', 2, $event)">
                        <div class="heading-preview heading-2">Heading 2</div>
                    </button>
                    <button class="heading-option" (click)="onHeadingSelected('heading', 3, $event)">
                        <div class="heading-preview heading-3">Heading 3</div>
                    </button>
                    <button class="heading-option" (click)="onHeadingSelected('paragraph', undefined, $event)">
                        <div class="heading-preview body">Body</div>
                    </button>
                </div>
                }
            </div>
        </div>
    </div>
    }

    <!-- Ask Bob Input -->
    @if (showInput && editorView) {
    <div class="ask-bob-input-container" [style.top.px]="toolbarPosition.top" [style.left.px]="toolbarPosition.left">
        <div class="ask-bob-input-wrapper">
            <app-input #bobInput class="ask-bob-input" placeholder="Edit or explain..." [(ngModel)]="inputValue"
                [class]="'w-full'" [rows]="1" (input)="autoResizeTextarea()" (keydown)="onKeyDown($event)"></app-input>
            <app-button class="ask-bob-submit-button" variant="filled" severity="primary" [icon]="'arrow-up'"
                [iconSource]="'lucide'" [shape]="'circle'" [size]="'sm'" [disabled]="!inputValue.trim()"
                [enableThrottle]="true" (clicked)="onInputSubmit()"></app-button>
        </div>
    </div>
    }
</div>